import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import SweetAlert from 'sweetalert-react';

import * as UserActions from '../../../actions/userActions';
import Loader from '../../../components/commons/loader/loader';

class ForgotPasswordPage extends Component {

  constructor(props){
    super(props);
    this.state = {
      email:'',
      showAlert: false,
      swalParams: {
        title: ""
      }
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {

    window.onkeydown = null;
  }

  render() {

    const {email, showAlert, swalParams} = this.state;
    const {loading} = this.props;
    return (
      <div className="page forgot-password-page">
        <div className="container">
          <h1 className="page-title">Forgot Password</h1>
          <div className="row">
            <div className="col-md-6">
              <form onSubmit={this.onSubmit}>
                <input required type="email" aria-label="email" className="email-input" onChange={(e)=>this.setState({email:e.target.value})} value={email} placeholder="Enter email"/>
                <button type="submit" className="reset-password-button" >Reset Password</button>
              </form>
            </div>
          </div>
        </div>
        <Loader visibility={loading} />
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams} onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    )
  }

  onSubmit(e) {
    e.preventDefault();
    let {email} = this.state;
    console.log(email);
    if(email){
      this.props.dispatch(UserActions.requestResetPassword(email, response => {
        console.log("forgot password response", response);
        if(response.status) {
          this.setState({showAlert: true, swalParams: {
            title: "Password reset link has been sent to your email address",
            type: "success",
            showConfirmButton: false
          }})
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        } else {
          let error= response.data.message
           ? response.data.message
           : "Something went wrong, please try again later!";
          this.setState({showAlert: true, swalParams: {
            title: error,
            type: "error",
            showConfirmButton: false
          }})
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        }
      }))
    }
  }
}


export default connect((state) => {
  return {
    error: state.getIn(['users', 'error']),
    loading: state.getIn(['users', 'loading'])
  };
})(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/containers/begin/forgot-password/ForgotPasswordPage.js